// These constants are injected via webpack environment variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application

// export const VERSION = process.env.VERSION;
// export const DEBUG_INFO_ENABLED = !!process.env.DEBUG_INFO_ENABLED;
// export const SERVER_API_URL = process.env.SERVER_API_URL;
// export const BUILD_TIMESTAMP = process.env.BUILD_TIMESTAMP;

// local server config
// export const SERVER_API_URL = 'http://sandbox.dornikacrm.ir/';
// export const SERVER_API_URL = 'http://localhost:8080/';
// export const COMPANY_NAME = 'koosha';
// export const SHOW_SALES_PARAM = true;
// export const SHOW_TICKET = true;
// export const SHOW_STORE = true;
// export const SHOW_SUPPORT = true;
// export const SHOW_SUPPORT = true;
// export const SHOW_VOIP = true;
// export const SHOW_PROJECT_MNG = true;
// export const SHOW_SMS = true;
// export const SHOW_SETTING = false;
// export const CLIENT_MANAGER_SHOW = true;
// export const ASSIGN_CUSTOMER_USER = false;
// export const BUSINESS_COLOR = 'default';



// Mr kafili server config
// export const SERVER_API_URL = 'http://windezh-crm.com/';
// export const SERVER_API_URL = 'http://37.255.205.239/';
// export const SHOW_TICKET = false;
// export const CLIENT_MANAGER_SHOW = false;
// export const ASSIGN_CUSTOMER_USER = false;
//
// export const COMPANY_NAME = 'koosha123';
// export const SHOW_SALES_PARAM = true;
// export const BUSINESS_TYPE = 'project';
// export const SHOW_STORE = false;
// export const SHOW_SUPPORT = true;
// export const SHOW_VOIP = false;
// export const SHOW_PROJECT_MNG = true;
// export const SHOW_SMS = true;
// export const SHOW_SETTING = false;
// export const BUSINESS_COLOR = 'default';










// Mr parsaee server config
// export const SERVER_API_URL = 'http://94.183.164.188/';
// export const COMPANY_NAME = 'parse';

// export const SERVER_API_URL = 'http://localhost:8080/';

// export const SERVER_API_URL = 'http://parsecompany.com/';
// export const SERVER_API_URL = 'http://94.183.164.188/';
// export const COMPANY_NAME = 'koosha';
// export const SHOW_TICKET = true;
// export const SHOW_SUPPORT = true;
// export const SHOW_VOIP = true;
// export const SHOW_PROJECT_MNG = true;
// export const SHOW_SMS = true;
// export const CLIENT_MANAGER_SHOW = true;
// export const SHOW_SALES_PARAM = false;
// export const SHOW_SETTING = false;
// export const SHOW_STORE = false;
// export const ASSIGN_CUSTOMER_USER = false;
// export const BUSINESS_COLOR = 'default';
// export const BUSINESS_TYPE = 'project';

//
//
// export const BUSINESS_TYPE = 'project';


// export const SERVER_API_URL = 'http://localhost:8081/';
// export const SERVER_API_URL = 'http://86.104.32.154/';
export const SERVER_API_URL = 'http://parsecompany.ir/';
// export const SERVER_API_URL = 'https://crm.rasadpoint.com/';

// export const SERVER_API_URL = 'http://37.255.225.237/';
// export const COMPANY_NAME = 'koosha';
// export const SHOW_TICKET = false;
// export const SHOW_SUPPORT = false;
// export const SHOW_VOIP = false;
// export const SHOW_PROJECT_MNG = true;
// export const SHOW_SMS = true;
// export const CLIENT_MANAGER_SHOW = false;
// export const SHOW_SALES_PARAM = false;
// export const SHOW_SETTING = false;
// export const SHOW_STORE = false;
// export const ASSIGN_CUSTOMER_USER = false;
// export const BUSINESS_COLOR = 'default';
//
//
// export const BUSINESS_TYPE = 'project';



// Mr pars koosha server config
// export const SERVER_API_URL = 'http://parskoosha.dornikacrm.ir/';
// export const COMPANY_NAME = 'koosha';
// export const SHOW_SALES_PARAM = true;
// export const SHOW_PROJECT_MNG = true;
// export const SHOW_SMS = true;
// export const SHOW_STORE = false;
// export const SHOW_SUPPORT = false;
// export const SHOW_VOIP = false;
// export const SHOW_TICKET = false;
// export const SHOW_SETTING = false;
// export const CLIENT_MANAGER_SHOW = false;
// export const ASSIGN_CUSTOMER_USER = false;
// export const BUSINESS_COLOR = 'default';



// demo server config
// export const SERVER_API_URL = 'http://localhost:8081/';
//
//  export const SERVER_API_URL = 'https://demo.dornikacrm.ir/';
// export const SERVER_API_URL = 'https://rasadme.ir/';

export const COMPANY_NAME = 'koosha123';
export const SHOW_SALES_PARAM = true;
export const BUSINESS_TYPE = 'project';
export const SHOW_TICKET = true;
export const SHOW_PROJECT_PHASE_PROGRESS = false;
export const SHOW_STORE = true;
export const SHOW_SUPPORT = true;
export const SHOW_VOIP = true;
export const SHOW_PROJECT_MNG = true;
export const SHOW_ACCOUNTING = true;
/** دکمه افزودن بالای لیست پیش‌فاکتور پروژه و فاکتور پروژه */
export const SHOW_PROJECT_FACTOR_ADD = false;
export const SHOW_SMS = true;
export const SHOW_SETTING = true;
export const CLIENT_MANAGER_SHOW = false;
export const ASSIGN_CUSTOMER_USER = false;
export const BUSINESS_COLOR = 'defaultdark';
/** true = توضیحات در فرم پیگیری الزامی است */
export const TRANSACTION_DESCRIPTION_REQUIRED = false;
// export const SERVER_API_URL = 'http://localhost:8080/';
//
//  // export const SERVER_API_URL = 'https://demo.dornikacrm.ir/';
// export const COMPANY_NAME = 'sahand';
// export const SHOW_SALES_PARAM = false;
// export const BUSINESS_TYPE = 'project';
// export const SHOW_TICKET = false;
// export const SHOW_STORE = false;
// export const SHOW_SUPPORT = false;
// export const SHOW_VOIP = false;
// export const SHOW_PROJECT_MNG = false;
// export const SHOW_SMS = false;
// export const SHOW_SETTING = false;
// export const CLIENT_MANAGER_SHOW = false;
// export const ASSIGN_CUSTOMER_USER = false;
// export const BUSINESS_COLOR = 'default';


// demo server config
//  export const SERVER_API_URL = 'http://pasargad.dornikacrm.ir/';
// export const COMPANY_NAME = 'pasargad';
// export const SHOW_SALES_PARAM = true;
// export const BUSINESS_TYPE = 'project';
// export const SHOW_TICKET = true;
// export const SHOW_STORE = true;
// export const SHOW_SUPPORT = true;
// export const SHOW_VOIP = false;
// export const SHOW_PROJECT_MNG = true;
// export const SHOW_SMS = true;
// export const SHOW_SETTING = false;
// export const CLIENT_MANAGER_SHOW = true;
// export const ASSIGN_CUSTOMER_USER = false;
// export const BUSINESS_COLOR = 'default';
//

// demo server config
// export const SERVER_API_URL = 'http://clinic.dornikacrm.ir/';
// export const COMPANY_NAME = 'clinic_demo';
// export const SHOW_SALES_PARAM = true;
// export const BUSINESS_TYPE = 'project';
// export const SHOW_TICKET = false;
// export const SHOW_STORE = true;
// export const SHOW_SUPPORT = false;
// export const SHOW_VOIP = false;
// export const SHOW_PROJECT_MNG = false;
// export const SHOW_SMS = true;
// export const SHOW_SETTING = false;
// export const CLIENT_MANAGER_SHOW = true;
// export const ASSIGN_CUSTOMER_USER = false;
// export const BUSINESS_COLOR = 'default';


// dornika crm server config
//  export const SERVER_API_URL = 'http://sandbox.dornikacrm.ir/';
// export const SERVER_API_URL = 'http://crm.dornikacrm.ir/';
// export const BUSINESS_TYPE = 'salesCycle';
// export const SHOW_TICKET = true;
// export const CLIENT_MANAGER_SHOW = true;
// export const SHOW_SMS = true;
// export const SHOW_SUPPORT = true;
// export const SHOW_PROJECT_MNG = true;
// export const SHOW_SETTING = false;
// export const ASSIGN_CUSTOMER_USER = false;
// export const SHOW_SALES_PARAM = false;
// export const SHOW_STORE = true;
// export const SHOW_VOIP = false;
// export const BUSINESS_COLOR = 'default';
// export const COMPANY_NAME = '';



// dornika crm server config
// export const SERVER_API_URL = 'http://atena.dornikacrm.ir/';
// export const BUSINESS_TYPE = 'salesCycle';
// export const SHOW_TICKET = false;
// export const CLIENT_MANAGER_SHOW = false;
// export const SHOW_SMS = true;
// export const SHOW_SUPPORT = false;
// export const SHOW_PROJECT_MNG = false;
// export const SHOW_SETTING = false;
// export const ASSIGN_CUSTOMER_USER = false;
// export const SHOW_SALES_PARAM = false;
// export const SHOW_STORE = false;
// export const SHOW_VOIP = false;
// export const BUSINESS_COLOR = 'default';
// export const COMPANY_NAME = '';


